var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.30859 10C8.06931 10 10.3086 7.76072 10.3086 5C10.3086 2.23928 8.06931 0 5.30859 0C2.54787 0 0.308594 2.23928 0.308594 5C0.308594 7.76072 2.54787 10 5.30859 10ZM4.95144 2.14286C4.95144 1.94643 5.11216 1.78571 5.30859 1.78571C5.50503 1.78571 5.66575 1.94643 5.66575 2.14286V4.82858L7.31753 6.15C7.47111 6.27322 7.4961 6.49821 7.37288 6.65179C7.30323 6.73928 7.19967 6.78571 7.0943 6.78571C7.01573 6.78571 6.93715 6.7607 6.8711 6.70713L5.08539 5.27858C5.00146 5.21071 4.95147 5.10894 4.95147 5V2.14286H4.95144Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clockIcon.dbe6232240045e4395ea259df5b9877f.svg";
export { ForwardRef as ReactComponent };